import FileLinkB64 from './FileLinkB64';
export default FileLinkB64;
